import React, {Component} from 'react';
import '../../styles/Home.css'

export default class RealizacjaTPayFail extends Component {

    constructor(props) {
        super(props);

        sessionStorage.removeItem('koszyk');
    }

    render() {
        return <div className="container">
            <hr/>
            <div className="rezerwacjaPomyslnie" id='divToPrint'>
                <h2><i className="fa fa-2x fa-times" style={{color: 'red'}}> </i>Wystąpił błąd</h2>
                <h5 style={{fontWeight: 400}}>Podczas dokonywania płatności wystąpił błąd. <a
                    href={sessionStorage.getItem('platnosc').toString()}>Spróbuj ponownie.</a></h5>
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/koszyk/finalizacja/RealizacjaTPayFail.js